module.exports = __webpack_public_path__ + "img/1439430286.f6485d72.jpg";